var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",class:[ _vm.active ? 'active show' :'' ],attrs:{"id":_vm.idcontent,"role":"tabpanel","aria-labelledby":(_vm.idcontent + "-tab")}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }